// The current file development is no longer in active phase but the code will be kept as is.
// Please be advised that we have discontinued the sync for this file with the commercial version of Kendo UI for jQuery.
// To take advantage of new features please visit (https://www.telerik.com/kendo-jquery-ui) and consider upgrading to a commercial license.

// IMPORTANT: Reporting relies on this file to be present as it is used to remove license validation in their bundle.
export const __meta__ = {
    id: "licensing",
    name: "Licensing",
    category: "framework",
    description: "The licensing mechanism for Kendo UI for jQuery.",
    depends: []
};
export const addWatermarkOverlayAndBanner = () => { };
export const validatePackage = () => { };

export const packageMetadata = {
    version: "$KENDO_VERSION".replace(/^\s+|\s+$/g, '')
}